import React from "react";
import { Chip } from "./chip";
import classNames from 'classnames';
import { PaymentMethod } from "../shared/types";
import { helpers } from "@shared";

export const PaymentMethodCard = ({ paymentMethod, isDefault, makeDefault, idx }: {
    paymentMethod: PaymentMethod;
    isDefault: boolean;
    makeDefault?: (idPaymentMethod: string) => void;
    idx?: number;
}) => {
    const { idPaymentMethod, sourceName, accountType, last4 } = paymentMethod;
    const isDisabled = !!paymentMethod.disabledAt;

    let chip: React.ReactElement | null = null;
    if (isDisabled) {
        chip = <Chip color="red" text="Disabled" />;
    } else if (isDefault) {
        chip = <Chip color="green" text="Default" />;
    }

    return (
        <div key={idPaymentMethod} id={`pm-${idx}`} className={classNames(
            `flex flex-col shadow-sb p-3 pl-5 rounded-lg`,
            isDisabled ? 'bg-[#9CA3AF]' : 'bg-[#ECEBEB]',
        )}>
            <div className="flex flex-row gap-x-3">
                <span className="font-bold text-lg">{sourceName}</span>
                <div className="ml-auto">
                    { chip }
                </div>
            </div>
            <h3 className="text-gray-600">{`${helpers.nullPrint(accountType)} *****${last4}`}</h3>
            {
                !isDefault && !isDisabled && makeDefault &&
                <div className="w-28 pt-2">
                    <button type="button" className="btn border-2 p-1 bg-sb-bg text-blue-on" onClick={() => makeDefault(idPaymentMethod)}>Make Default</button>
                </div>
            }
        </div>
    );
};